"use client";

import Link from 'next/link';
import { useState } from 'react';

const navLinks = [
    { href: '/', label: 'Home' },
    { href: '/results', label: 'Results' },
    { href: '/learn', label: 'Learn' },
    { href: '/faq', label: 'FAQ' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' },
];

export default function SiteNav() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <nav className="border-b bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60 sticky top-0 z-50">
            <div className="container mx-auto px-4 py-3 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <Link href="/" className="text-lg font-semibold tracking-tight">
                        Thomas GIA Practice
                    </Link>
                    <span className="hidden sm:inline text-xs text-gray-500 border border-gray-200 px-2 py-0.5 rounded-full">Free</span>
                </div>

                <div className="hidden md:flex items-center gap-6">
                    <Link href="/" className="text-gray-700 hover:text-blue-600">Practice</Link>
                    <Link href="/mock" className="text-gray-700 hover:text-blue-600">Mock Test</Link>
                    {navLinks.map(link => (
                        <Link key={link.href} href={link.href} className="text-gray-700 hover:text-blue-600">
                            {link.label}
                        </Link>
                    ))}
                </div>

                <button
                    aria-label="Toggle navigation menu"
                    className="md:hidden p-2 rounded hover:bg-gray-100"
                    onClick={() => setMenuOpen(v => !v)}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg>
                </button>
            </div>

            {menuOpen && (
                <div className="md:hidden border-t bg-white">
                    <div className="container mx-auto px-4 py-3 grid gap-2">
                        <Link href="/" className="py-2 text-gray-700 hover:text-blue-600" onClick={() => setMenuOpen(false)}>Practice</Link>
                        <Link href="/mock" className="py-2 text-gray-700 hover:text-blue-600" onClick={() => setMenuOpen(false)}>Mock Test</Link>
                        {navLinks.map(link => (
                            <Link key={link.href} href={link.href} className="py-2 text-gray-700 hover:text-blue-600" onClick={() => setMenuOpen(false)}>
                                {link.label}
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </nav>
    );
}


